<template>
  <div>
    <layout-one>
      <el-form
        :model="form"
        label-width="160px"
        :inline="true"
        ref="form"
        :rules="rules"
      >
        <div class="section">
          <h4>时间设置</h4>
          <div class="sectionBox">
            <el-form-item label="考试批次">
              <span>{{ planCode }}</span>
            </el-form-item>
          </div>
          <div class="sectionBox">
            <el-form-item label="场次">
              <span>{{ sectionName }}</span>
            </el-form-item>
          </div>
          <div class="sectionBox">
            <el-form-item label="考试起止时间" :required="true">
              <el-form-item prop="beginTime">
                <el-date-picker
                  :value-format="dataFormat"
                  v-model="form.beginTime"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </el-form-item>
              至
              <el-form-item prop="endTime" class="ml8">
                <el-date-picker
                  :default-time="defaultTime"
                  :value-format="dataFormat"
                  v-model="form.endTime"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-form-item>
          </div>
        </div>
        <div class="section mt20">
          <h4>考点考场设置</h4>
          <div class="sectionBox">
            <el-form-item label="" class="ml30">
              <div>
                <span
                  >已选<span class="col_blue">{{ siteSelectList.length }}</span
                  >个考点</span
                >
                <span
                  >共计<span class="col_blue">{{ allSeatNumber }}</span
                  >个考位</span
                >
              </div>
              <div class="optionContainer">
                <div class="optionsBox mr30">
                  <div class="top">
                    <div>考点选择</div>
                    <!-- <div class="searchCourse ml30">
                                            <el-input  placeholder="快捷搜索" v-model="siteScopeText"></el-input>
                                            <div class="searchPos">
                                                <i class="iconfont icon-sousuo"></i>
                                            </div>   
                                        </div> -->
                  </div>
                  <el-checkbox
                    class="pl20"
                    :indeterminate="isAllSite"
                    v-model="checkAllSite"
                    @change="handleCheckAllSite"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    class="p20 pt0"
                    v-model="siteSelectList"
                    @change="handleCheckedSite"
                  >
                    <el-checkbox
                      v-for="item in siteSelectData"
                      :label="item"
                      :key="item.id"
                      >{{
                        `${item.name}(${item.classList.length})`
                      }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <div class="optionsBox">
                  <div class="top">
                    <div>教室选择</div>
                    <!-- <div class="searchCourse ml30">
                              <el-input  placeholder="快捷搜索" v-model="classScopeText"></el-input>
                              <div class="searchPos">
                                  <i class="iconfont icon-sousuo"></i>
                              </div>  
                          </div> -->
                  </div>
                  <el-checkbox
                    class="pl20"
                    :indeterminate="isAllClass"
                    v-model="checkAllClass"
                    @change="handleCheckAllClass"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    class="p20 pt0"
                    v-model="classSelectList"
                    @change="handleCheckedClass"
                  >
                    <el-checkbox
                      v-for="item in classSelectData"
                      :label="item"
                      :key="item.id"
                      >{{ `${item.name}(${item.seatNumber})`
                      }}{{ examinationPoints(item.placeId) }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="section mt20">
          <h4>考试科目设置</h4>
          <div class="sectionBox">
            <el-form-item label="选择考试科目">

              <div class="stationBox">
                  <!-- 快捷搜索功能 -->
                  <div class="stationTop">
                    <div class="searchCourse ml30">
                      <el-input
                        placeholder="快捷搜索"
                        v-model="courseStr"
                      ></el-input>
                      <div class="searchPos">
                        <i class="iconfont icon-sousuo"></i>
                      </div>
                    </div>
                  </div>
                  <!-- 全选 -->
                  <el-checkbox
                    :indeterminate="isIndeterminateStudentSchool"
                    v-model="checkAllStudentSchool"
                    @change="CheckAllStudentSchoolFN"
                  >
                    全选
                  </el-checkbox>
                  <el-checkbox-group
                    v-model="form.coursePaperList"
                    @change="CheckedStudentSchools"
                  >
                    <el-checkbox
                      v-for="school in courseSelectData"
                      :label="school.planCourseId"
                      :key="school.planCourseId"
                      :title="school.courseName"
                      >{{ school.courseName }}</el-checkbox
                    >
                  </el-checkbox-group>
              </div>

            </el-form-item>

          </div>

        </div>
      </el-form>


    </layout-one>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { getSelectPlace } from "@/http/modules/baseSet/examSite";
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import {
  getSessionName,
  addSection,
  editSection,
  getPaperFn,
  getSingleSection,
} from "@/http/modules/examSet/section";
import { flatten } from "@/help/publicFn";
export default {
  name: "addSection",
  data() {
    return {
      // 时间组件设置默认时间 23:59:59
      defaultTime: "23:59:59",
      
      isEdit: false,
      saveMethods: "addOrEdit",
      backMethods: "goIndex",
      dataFormat: "yyyy-MM-dd HH:mm:ss",
      planCode: "",
      sectionName: "",
      siteScopeText: "",
      classScopeText: "",
      siteData: [],
      siteSelectList: [],
      classData: [],
      classSelectList: [],
      checkAllSite: false,
      isAllSite: false,
      checkAllClass: false,
      isAllClass: false,
      courseData: [],
      curCourseId: "",
      cpList: [],
      courseStr: "",
      tableHeader: [
        {
          title: "课程",
          prop: "courseName",
        },
        {
          title: "试卷",
          prop: "paperName",
        },
        {
          title: "答卷时长",
          prop: "examTime",
        },
        {
          title: "操作",
          type: "buttons",
          width: "60",
          btnList: [
            {
              title: "删除",
              click: this.deleteCoursePaper,
            },
          ],
        },
      ],
      paperOptions: [
        {
          title: "关键词",
          type: "input",
          placeholder: "试卷名称",
          requestKey: "searchKey",
        },
      ],
      paperSelectForm: {
        searchKey: "",
      },
      paperListParams: {
        courseIds: "",
        page: 1,
        size: 10,
      },
      paperDialog: false,
      paperTableOption: {
        multiple: true,
        selectTable: this.isCanSelectFn,
      },
      paperTableData: [],
      paperTableHeader: [
        {
          title: "试卷名称",
          prop: "name",
        },
        {
          title: "难度",
          prop: "difficultyDegree",
        },
        {
          title: "创建日期",
          prop: "createTime",
        },
        {
          title: "专业",
          prop: "courseName",
        },
        {
          title: "使用次数",
          prop: "usedCount",
        },
        {
          title: "总分",
          prop: "score",
        },
        // {
        //     title: '操作',
        //     type:"buttons",
        //     width:"80",
        //     btnList:[
        //         {
        //             title: "查看",
        //             click: this.checkStudent
        //         }
        //     ]
        // },
      ],
      paperSelectList: [],
      paperPagination: {
        total: 0,
      },
      form: {
        planId: "",
        name: "",
        beginTime: "",
        endTime: "",
        time: 90,
        classIdList: "",
        coursePaperList: [],
      },
      rules: {
        beginTime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        time: [
          { type: "number", message: "答题时长必须为数字值", trigger: "blur" },
        ],
      },
      courseForm: {
        examTime: "",
      },
      courseRules: {
        examTime: [
          {
            required: true,
            type: "number",
            message: "答题时长必须为数字值",
            trigger: "blur",
          },
        ],
      },
      isIndeterminateStudentSchool: true,
      checkAllStudentSchool: false,
    };
  },
  computed: {
    courseSelectData() {
      return this.courseStr ? this.courseData.filter( (item) => item.courseName.indexOf(this.courseStr) > -1) : this.courseData
    },
    siteSelectData() {
      return this.siteData.filter((item) => item.id);
    },
    classSelectData() {
      return this.classData;
    },
    allSeatNumber() {
      return this.classSelectList.reduce((a, b) => {
        return a + parseInt(b.seatNumber);
      }, 0);
    },
  },
  watch: {
    siteSelectList: function (val) {
      let temp = val.map((item) => item.classList);
      this.classData = flatten(temp);
      let checkedCount = val.length;
      this.checkAllSite = checkedCount === this.siteSelectData.length;
      this.isAllSite =
        checkedCount > 0 && checkedCount < this.siteSelectData.length;
    },
    classSelectList: function (val) {
      let checkedCount = val.length;
      this.checkAllClass =
        checkedCount > 0 && checkedCount === this.classSelectData.length;
      this.isAllClass =
        checkedCount > 0 && checkedCount < this.classSelectData.length;
    },
    classSelectData: function (val) {
      if (!val || val.length < 1) {
        this.classSelectList = [];
        return;
      }
      this.classSelectList = this.classSelectList.filter((item) =>
        val.includes(item)
      );
    },
  },
  created() {

    this.initData();
  },
  mounted() {
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),
    CheckAllStudentSchoolFN(val) {
      let allData = this.courseData.map((item) => item.planCourseId);
      this.form.coursePaperList = val ? allData : [];
      this.isIndeterminateStudentSchool = false;
    },
    CheckedStudentSchools(value) {
      let checkedCount = value.length;
      this.checkAllStudentSchool = checkedCount === this.courseData.length;
      this.isIndeterminateStudentSchool =
        checkedCount > 0 && checkedCount < this.courseData.length;
    },
    examinationPoints(id) {
      let siteList = this.siteData.filter((item) => item.id === id);
      return siteList.length ? siteList[0].name : "";
    },
    async initData() {
      // 考试批次
      const { data: plan } = await getCurrentPlanFn({
        planId: this.$route.query.planId,
      });
      this.planCode = plan.name;
      this.planId = plan.id;
      // 根据批次获取课程
      const { data: courseData } = await getPlanCourseFn({ planId: plan.id });
      this.courseData = courseData;
      // 考点数据
      this.getSiteData();
    },
    async initPage() {
      if (this.$route.query.id) {
        this.isEdit = true;
        let id = this.$route.query.id;
        const { data } = await getSingleSection({ sessionId: id });
        this.sectionName = data.name;
        this.form.beginTime = data.beginTime;
        this.form.endTime = data.endTime;
        let placeList = data.placeList;
        this.form.coursePaperList = data.courseList.map((item)=>{
          return item.planCourseId
        });
        // 考点教室

        this.siteSelectList = this.siteSelectData.filter(
          (item) => placeList.filter((bb) => bb.placeId == item.id).length > 0
        );
        let classIdList = flatten(placeList.map((item) => item.classIdList));
        let temp = flatten(this.siteSelectList.map((item) => item.classList));

        this.classSelectList = temp.filter(
          (item) => classIdList.filter((bb) => bb == item.id).length > 0
        );

        // 课程试卷
        //this.cpList = data.courseList;
      } else {
        // 场次名称
        const { data: sectionName } = await getSessionName({
          planId: this.$route.query.planId,
        });
        this.sectionName = sectionName;
      }
    },
    async getSiteData() {
      const { data } = await getSelectPlace();
      this.siteData = data;
      // 判断编辑
      this.initPage();
    },
    handleCheckedSite(value) {
      let checkedCount = value.length;
      this.checkAllSite = checkedCount === this.siteSelectData.length;
      this.isAllSite =
        checkedCount > 0 && checkedCount < this.siteSelectData.length;
    },
    handleCheckedClass(value) {

      let checkedCount = value.length;
      this.checkAllClass = checkedCount === this.classSelectData.length;
      this.isAllClass =
        checkedCount > 0 && checkedCount < this.classSelectData.length;
    },
    handleCheckAllSite(val) {
      let allData = this.siteSelectData;
      this.siteSelectList = val ? allData : [];
      this.isAllSite = false;
    },
    handleCheckAllClass(val) {
      let allData = this.classSelectData;
      this.classSelectList = val ? allData : [];
      this.isAllClass = false;
    },
    // addPaperDialog() {
    //   if (!this.curCourseId) {
    //     this.$message.error("请先选择课程");
    //     return false;
    //   }
    //   this.courseForm.examTime = "";

    //   this.getPaper();
    //   this.paperDialog = true;
    // },
    paperBatchOper(val) {
      this.currentSelect = val;
    },
    beforeDeal() {
      if (!this.currentSelect) {
        return;
      }
      let idList = [...this.paperSelectList];

      this.currentSelect.forEach((item) => {
        let isHave = idList.filter(
          (selectItem) => selectItem.id == item.id
        ).length;
        if (!isHave) {
          idList.push(item);
        }
      });
      this.paperSelectList = idList;
    },
    paperChangeSize(num) {
      this.paperListParams.size = num;
      this.getPaper();
    },
    paperChangePage(p) {
      this.paperListParams.page = p;
      this.getPaper();
    },
    async getPaper() {
      this.paperListParams.courseIds = Object.assign({}, this.curCourseId);
      const { data } = await getPaperFn(this.paperListParams);

      this.paperSelectList = []; // 重新获取课程的时候  已选课程置空
      this.paperTableData = data.papers;
      this.paperPagination.total = data.total;
    },
    dealCoursePaper() {
      this.beforeDeal();
      this.$refs["courseForm"].validate(async (valid) => {
        if (valid) {
          // let curCourseObj = this.courseData.filter(
          //   (item) => item.courseId === this.curCourseId
          // )[0];

          // console.log(curCourseObj)
          // this.cpList = this.cpList.concat(
          //   this.paperSelectList.map((item) => {
          //     return {
          //       planCourseId: curCourseObj.planCourseId,
          //       courseName: curCourseObj.courseName,
          //       paperId: item.id,
          //       paperName: item.name,
          //       examTime: this.courseForm.examTime,
          //       judgementMode:item.judgementMode
          //     };
          //   })
          // );

          // // 同一课程答卷时长一样
          // this.cpList.forEach((item) => {
          //   if (item.planCourseId == curCourseObj.planCourseId) {
          //     item.examTime = this.courseForm.examTime;
          //   }
          // });
          // 去重
          // let temp = [];
          // this.cpList.forEach((item) => {
          //   let isHave = temp.some(
          //     (tempItem) => tempItem.paperId === item.paperId
          //   );
          //   if (!isHave) {
          //     temp.push(item);
          //   }
          // });
          // this.cpList = temp;
          this.paperDialog = false;
        }
      });
    },
    deleteCoursePaper(row) {
      this.cpList = this.cpList.filter((item) => item.paperId != row.paperId);
      this.paperSelectList = this.paperSelectList.filter(
        (item) => item.paperId != row.paperId
      );
    },
    addOrEdit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.name = this.sectionName;
          this.form.planId = this.planId;
          if (!this.classSelectList.length) {
            this.$message.error("请选择考点和教室");
            return false;
          }

          this.form.classIdList = this.classSelectList
            .map((item) => item.id)
            .join();
          // if (!this.cpList.length) {
          //   this.$message.error("请设置课程和考卷");
          //   return false;
          // }






          // 考试科目设置
          let params = { ...this.form }
          if (params.coursePaperList.length === 0) {
            this.$message.warning("请选择考试科目！")
            return
          }
          params.coursePaperList =  params.coursePaperList.join(",")






          if (this.isEdit) {
            params.sessionId = this.$route.query.id;
          }
          params.placeIdList = [];
          if (this.isEdit) {
            params.placeIdList = this.siteSelectList
              .map((e) => {
                return e.id;
              })
              .join();
          }
          const dealFn = this.isEdit ? editSection : addSection;

          const { code } = await dealFn(params);
          if (code == 1) {
            this.$otsPopPro({
              content: this.isEdit ? "修改成功" : "添加成功",
              isNeedCancel: false,
              okName: "确定",
            })
              .then(() => {
                this.goIndex();
              })
              .catch(() => {});
          }
        } else {
          return false;
        }
      });
    },
    goIndex() {
      this.$router.push({
        path: "/sectionList/section",
        query: {
          id: this.$route.query.planId,
        },
      });
    },
    isCanSelectFn(row) {
      return !this.cpList.some((item) => item.paperId == row.id);
    },
  },
};
</script>
<style lang="less" scoped>
.stationBox {
  width: 1000px;
  max-height: 300px;
  background-color: #f8f9fc;
  overflow-y: auto;
  padding: 20px 70px;
  border-radius: 8px;
  .stationTop {
    display: flex;
    margin-bottom: 20px;
  }
  .searchCourse {
    position: relative;
    .searchPos {
      width: 40px;
      height: 18px;
      line-height: 18px;
      border-left: 1px solid #e1e6ed;
      position: absolute;
      right: 0;
      top: 11px;
      color: #c2c6cc;
      font-size: 14px;
      i {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
/deep/ .el-checkbox {
  width: 360px;
  overflow: hidden;
  white-space: nowrap;
}

.section {
  border-bottom: 1px solid #f1f2f5;
  h4 {
    margin-bottom: 30px;
  }
  .sectionBox {
    .lang {
      width: 512px;
    }
  }
  .editor {
    width: 1000px;
  }
  /deep/ .el-form-item {
    margin-bottom: 30px !important;
  }
  /deep/ .el-radio-button__inner {
    margin-right: 16px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    width: 64px;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }
}
.optionContainer {
  display: flex;
  max-height: 600px;
}
.optionsBox {
  // display: inline-block;
  background-color: #f8f9fc;
  width: 400px;
  max-height: 100%;
  border-radius: 8px;
  // background-color: #ccc;
  overflow-y: auto;
  vertical-align: top;
  .top {
    display: flex;
    padding: 10px 20px;
    border-bottom: 1px solid #f1f2f5;
    .searchCourse {
      position: relative;
      // /deep/ .el-input{
      //     width: 240px;
      //     .el-input__inner {
      //         height: 32px!important;
      //         line-height: 32px!important;
      //         border-radius: 40px!important;
      //     }
      // }
      .searchPos {
        width: 40px;
        height: 18px;
        line-height: 18px;
        border-left: 1px solid #e1e6ed;
        position: absolute;
        right: 0;
        top: 11px;
        color: #c2c6cc;
        font-size: 14px;
        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  /deep/ .el-checkbox {
    display: block;
  }
}
</style>
